import { render, staticRenderFns } from "./SecretariaGrafico.vue?vue&type=template&id=8c89b1ca&scoped=true"
import script from "./SecretariaGrafico.vue?vue&type=script&lang=js"
export * from "./SecretariaGrafico.vue?vue&type=script&lang=js"
import style0 from "./SecretariaGrafico.vue?vue&type=style&index=0&id=8c89b1ca&prod&scoped=true&lang=css"
import style1 from "./SecretariaGrafico.vue?vue&type=style&index=1&id=8c89b1ca&prod&lang=scss"
import style2 from "./SecretariaGrafico.vue?vue&type=style&index=2&id=8c89b1ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c89b1ca",
  null
  
)

export default component.exports